"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserGroupDetailPageActions = exports.UserGroupDetailPage = exports.UserGroupListPage = void 0;
var userGroupListPage_1 = require("./userGroupListPage");
exports.UserGroupListPage = userGroupListPage_1.default;
var userGroupDetailPage_1 = require("./userGroupDetailPage");
exports.UserGroupDetailPage = userGroupDetailPage_1.default;
var userGroupDetailPageActions_1 = require("./userGroupDetailPageActions");
exports.UserGroupDetailPageActions = userGroupDetailPageActions_1.default;
